<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addBtnClick" v-if="auth_control.have_add_auth">新增轮播图</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="序号"
		      align="center"
		      width="120"
        >
		    </el-table-column>
		    
		    <el-table-column
		      label="轮播图片"
		      align="center"
        >
          <template slot-scope="scope">
             <img :src="imgDomain + scope.row.carousel_img"  class="carousel-img">
          </template>
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editServiceClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
         	    <span class="opration-item" @click="deleteServiceClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
    </div>
    <common-dialog
    title="删除轮播图"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		   是否删除轮播图？
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { carouselList, deleteCarousel } from '@/api/content-manage';
import { mapState } from 'vuex';
import CommonDialog from '@/components/CommonDialog';

export default {
  name: 'slideimgmanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      handle_row: {},
      auth_control: {
        have_add_auth: false,
        have_edit_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
  	}
  },
  computed: {
  	...mapState(['imgDomain', 'operationList'])
  },
  mounted() {
    this.getCarouselList();
    this.handleThreeRules();
  },
  components: {
     CommonDialog,
  },
  methods: {
  	addBtnClick() {
  		if (this.tableData.length < 6) {
  		  this.$router.push('/slideimg-manage/add-slide-img');
  	  } else {
        this.$message({
        	type: 'warning',
        	message: '轮播图已达上限（6张）, 无法再添加'
        })
  	  }
  	},
  	async getCarouselList() {
  		const { data, status } = await carouselList();
  		if (status !== 200) return
  		this.tableData = data.data;
  	},
  	deleteServiceClick(row) {
  		this.handle_row = row;
  		this.dialogVisible = true;
  	},
  	dialogCancelClick() {
  		this.dialogVisible = false;
  	},
  	dialogClose() {
      this.getCarouselList();
  	},
  	async dialogConfirmClick() {
  		const { status } = await deleteCarousel(this.handle_row.uuid);
  		if ( status !== 200 ) return
  		this.dialogVisible = false;
  	},
  	editServiceClick(row) {
      this.$router.push({
      	path: '/slideimg-manage/edit-slide-img',
      	query: {
      		uuid: row.uuid
      	}
      })
  	},
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('添加') !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf('编辑') !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      })
     console.log(this.three_rules, 'three rulesslid img')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
  margin-bottom: 40px;
  .carousel-img {
    max-width: 500px;
    max-height: 300px;
  }
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
}
</style>
